import {

    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    PROFILE_FAILED,
    PROFILE_SUCCESS,
    SYSTEM_SETTINGS_UPDATED,
    TWO_FACTOR_REQUIRED,
    TWO_FACTOR_VERIFY,
    TWO_FACTOR_SUCCESS,
    TWO_FACTOR_FAIL,
    TWO_FACTOR_RESET,
    TWO_FACTOR_RESEND,
    UPDATE_USER_2FA,
  } from "../actions/types";

  const twoFactorInitial = {
    required: false,
    tempToken: null,
    delivery: null,
    maskedDestination: null,
    expiresIn: 90,
    loading: false,
    error: null,
  };

  // const user = JSON.parse(localStorage.getItem("user"));
  const initialState ={ isLoggedIn: false, user: null, profile:null, profileSuccess:false, twoFactor: twoFactorInitial };
  export default function (state = initialState, action) {
    //debugger;
    const { type, payload } = action;
    switch (type) {
      case SYSTEM_SETTINGS_UPDATED:
        // const {index, settings} = payload;
        // const profile = JSON.parse(JSON.stringify(state.profile));
        // profile.property_details[index].system_settings[0] = settings;
        
        //state.profile.property_details[index].system_settings[0] = settings;
        //const profile = state.profile
        //debugger; 
        state.profile = payload;
        return {...state};
        break;       
      case PROFILE_SUCCESS:
        state.profile = payload;
        return {
          ...state,
          profileSuccess:true,
          profile: payload,
        };
        break;
      case PROFILE_FAILED:
        return {
          ...state,
          profileSuccess: false,
          profile: null,
        };
        break;
      case TWO_FACTOR_REQUIRED:
        return {
          ...state,
          twoFactor: {
            ...twoFactorInitial,
            required: true,
            tempToken: payload.tempToken,
            delivery: payload.delivery,
            maskedDestination: payload.maskedDestination,
            expiresIn: payload.expiresIn,
          },
        };
      case TWO_FACTOR_VERIFY:
        return { ...state, twoFactor: { ...state.twoFactor, loading: true, error: null } };
      case TWO_FACTOR_SUCCESS:
        return { ...state, twoFactor: { ...state.twoFactor, loading: false, error: null } };
      case TWO_FACTOR_FAIL:
        return { ...state, twoFactor: { ...state.twoFactor, loading: false, error: payload } };
      case TWO_FACTOR_RESEND:
        return { ...state, twoFactor: { ...state.twoFactor, tempToken: payload.tempToken } };
      case TWO_FACTOR_RESET:
        return { ...state, twoFactor: { ...twoFactorInitial } };
      case UPDATE_USER_2FA:
        return { ...state, user: { ...state.user, enable_2fa: payload } };
      case LOGIN_SUCCESS:
        return {
          ...state,
          isLoggedIn: true,
          user: payload.user,
          twoFactor: { ...twoFactorInitial },
        };
        break;
      case LOGIN_FAIL:
        return {
          ...state,
          isLoggedIn: false,
          profileSuccess: false,
          user: null,
        };
        break;
      case LOGOUT:
        sessionStorage.clear();
        localStorage.clear();
        return {
          ...state,
          isLoggedIn: false,
          profileSuccess: false,
          user: null,
          profile:null,
          twoFactor: { ...twoFactorInitial },
        };
        break;
      default:
        return state;
    }
  }
  